import LEASTWANTEDTECHSBYFRAMEWORKS from 'data/mantechcar24/least-wanted-techs-by-framework.json';
import {
  Bar,
  BarChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import { StyledRecharts } from '../../shared/recharts/Recharts.styled';

const LeastWantedTechsByFrameworks: React.FC = () => {
  return (
    <div>
      <StyledRecharts>
        <ResponsiveContainer height={400} width="99%" minWidth={500}>
          <BarChart data={LEASTWANTEDTECHSBYFRAMEWORKS} layout="vertical">
            <XAxis
              type="number"
              allowDecimals={false}
              tickLine={false}
              padding={{ left: 20 }}
              tickFormatter={(tick) => {
                return `${tick}%`;
              }}
            ></XAxis>
            <YAxis
              type="category"
              dataKey="name"
              tickLine={false}
              width={120}
            />
            <Tooltip
              cursor={{ fill: '#ebe8df' }}
              labelStyle={{ display: 'none' }}
              separator=""
              formatter={(value: number) => [value.toFixed(1) + '%', '']}
              wrapperClassName="tooltip-y"
            />
            <Bar dataKey="value" fill="fill" barSize={12} radius={5} />
          </BarChart>
        </ResponsiveContainer>
      </StyledRecharts>
    </div>
  );
};

export default LeastWantedTechsByFrameworks;
